import { changeStatusRequestUseCase } from 'useCases/requestManagement/changeStatusRequestUseCase';

import { RequestService } from 'services/RequestService/RequestService';

import { alertEvent } from 'stores/Alert/AlertEvents';
import { authStore } from 'stores/AuthStore/AuthStore';
import { requestManagementEvent } from 'stores/RequestManagement/RequestManagementEvents';

import { StatusEnum } from 'domains/status';

const execute = async (form: any) => {
  try {
    const { sector } = authStore.getState();

    await RequestService.editValidityRequestManagementDetail({
      id: form.formId,
      userSector: sector,
      validityStart: form.startDate,
      validityEnd: form.endDate,
      examQty: form?.examQty ? Number(form.examQty) : null,
      prescriptionQty: form?.prescriptionQty ? Number(form.prescriptionQty) : null,
    });

    await changeStatusRequestUseCase.execute({ id: form.formId, status: StatusEnum.Active });

    requestManagementEvent({ isOpenAlertModal: true });
  } catch (error) {
    alertEvent({
      open: true,
      type: 'error',
      text: 'Não foi possível registrar sua solicitação',
    });
  } finally {
    requestManagementEvent({ isOpenEditValidityModal: false });
  }
};

export const editValidityModalRequestManagementUseCase = { execute };
